import React, {forwardRef} from "react";

import {ScrollView}  from 'react-native'




const Scroll = forwardRef((props, ref) => {

   
    return (
		<ScrollView ref={ref} contentContainerStyle={{flexGrow: 1}}> 
			{props.children}	
		</ScrollView>
		
	)
   
});


export default Scroll;
